<template>
    <div v-if="show" class="modal-overlay">
      <div class="modal-content">
        <slot name="header">{{ $t('SuccesConfirmationModal.success') }}</slot>
        <slot>{{ $t('SuccesConfirmationModal.successText') }}</slot>
        <div class="modal-buttons">
          <button @click="$emit('close')">{{ $t('SuccesConfirmationModal.closeButton') }}</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      show: Boolean,
    },
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
  }
  .modal-buttons {
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }

  .modal-buttons button {
    margin-left: 10px; 
    padding: 8px 12px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .modal-buttons button:first-child { 
    background-color: #146a40; 
    color: white;
  }
  </style>